import frDictionary from "@/locales/dictionaries-fr.json"

export function getSyncDictionary() {
  return frDictionary
}
